
export default {
  methods: {
    manageMouseLeave () {
      this.$emit(`submenuExited`, false);
    },
  },
};
